// App.js
import React from 'react';
import Navbar from './Components/Navbar';
import Hero from './Components/Hero';
import About from './Components/About';
import Skills from './Components/Skills';
import Projects from './Components/Projects';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import Certifications from './Components/Certication';
import Experience from "./Components/Expireance";
import Schooling from "./Components/School"

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      {/* <About /> */}
      <Schooling/>
      <Experience />
      <Skills />
      <Certifications />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
